/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import GraderInstructions from 'bundles/grading/components/staff-graded-assignments/top-bar/GraderInstructions';
import LastSavedStatus from 'bundles/grading/components/staff-graded-assignments/top-bar/LastSavedStatus';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import MoreActions from 'bundles/grading/components/staff-graded-assignments/top-bar/MoreActions';

const styles = {
  container: () => css`
    display: flex;
    align-items: center;
  `,
  iconContainer: () => css`
    margin: 0 var(--cds-spacing-400);
  `,
};

// Component for SGA top bar right justified controls
const RightControls = ({ showMoreActions }: { showMoreActions: boolean }) => {
  return (
    <div css={styles.container}>
      <LastSavedStatus />
      <GraderInstructions />
      {showMoreActions && <MoreActions />}
    </div>
  );
};

export default RightControls;
